﻿import { systemOperationsLogOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { rangeFilterUTC } from "../helpers/utils";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("system-operations-log"),
  endpoint: "system-operations-log",
  operations: systemOperationsLogOps,
  roleView: [ROLE.CUSTOMER_VIEW, ROLE.CUSTOMER_ADMIN, ROLE.EMZ_DEVELOPER],
  roleAdmin: [ROLE.CUSTOMER_ADMIN, ROLE.EMZ_DEVELOPER],
  baseRoute: "system-operations-log",
  singularName: (t) => t("System Operations Log"),
  name: (t) => t("System Operations Logs"),

  sendCulture: true,
  initialFilter: {
    sortBy: "timestamp",
    sortOrder: "descend",
  },
  filterFormatter: rangeFilterUTC,
  syncCustomerFilter: true,
});

export default conf;
